import React, { Component } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Documents from 'components/TeamFolders/Documents';
import Assets from 'components/TeamFolders/Assets';
import { Link } from 'react-router-dom';
import { CLOUD_FOLDER_TAB } from 'routes';
import CenteredContent from 'components/CenteredContent/CenteredContent';
import i18n from 'i18n/i18n';
import _ from 'lodash';

const localize = i18n.loc.localize;

const TABS = {
	ASSETS: 'assets'
};

const styles = theme => ({
	root: {
		background: `linear-gradient(to bottom, #eee ${9 * theme.spacing.unit}px, #fff ${9 * theme.spacing.unit}px)`,
	},
	tabContent: {
		paddingTop: `${6 * theme.spacing.unit}px`
	},
	centeredContent: {
		paddingTop: `${3 * theme.spacing.unit}px`
	}
});

@withStyles(styles)
class CloudFolder extends Component {
	state = {
		tab: 0
	};

	handleTabChange = (event, value) => {
		this.setState({ tab: value });
	};

	componentWillReceiveProps(nextProps, nextContext) {
		const { match, folders: { image, logo, component } } = nextProps;
		const tab = match.params.tab && match.params.tab.toLowerCase();
		const tabValue = (tab === TABS.ASSETS && this.areAssetsFoldersConnected(image, logo, component)) ? 1 : 0;

		if (match.params.tab && this.state.tab !== tabValue) {
			this.handleTabChange(null, tabValue);
		}
	}

	/**
	 * Check if any assets cloud folders are connected
	 *
	 * @param {*} image Image cloud folders array
	 * @param {*} logo Logo cloud folders array
	 * @param {*} component Component cloud folders array
	 * @returns
	 * @memberof CloudFolder
	 */
	areAssetsFoldersConnected(image, logo, component) {
		return (image.length > 0 || logo.length > 0 || component.length > 0);
	}

	render() {
		const { tab } = this.state;
		const { classes: { root, tabContent, centeredContent }, match, folders: { image, logo, component } } = this.props;
		const tabRoute = CLOUD_FOLDER_TAB.replace(':companyId', match.params.companyId);
		const showAssetsTab = this.areAssetsFoldersConnected(image, logo, component);

		return (
			<div className={root}>
				<CenteredContent className={centeredContent}>
					<Tabs value={tab}>
						<Tab
							label={localize('cloud-folders-documents')}
							disableRipple
							data-tid="tab-cloud-documents"
							component={Link}
							to={tabRoute.replace(':tab', 'documents')} />
						{showAssetsTab && < Tab
							label={localize('cloud-folders-assets')}
							data-tid="tab-cloud-assets"
							disableRipple
							component={Link}
							to={tabRoute.replace(':tab', 'assets')} />}
					</Tabs>
					<div className={tabContent}>
						{tab === 0 && <Documents match={match} type='document' />}
						{(showAssetsTab && tab === 1) && <Assets match={match} folders={{ image, logo, component }} />}
					</div>
				</CenteredContent>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	cloudFolders: {
		...state.cloudFolders,
		documentFolder: null,
		imageFolder: null
	},
	folders: _.get(state.companies.rawDataById[state.companies.selectedId], 'folders', {})

});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

CloudFolder.propTypes = {
	match: PropTypes.object.isRequired,
	classes: PropTypes.object,
	cloudFolders: PropTypes.object,
	folders: PropTypes.object
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CloudFolder);



// WEBPACK FOOTER //
// ./src/containers/CloudFolder/CloudFolder.js